<div class="payment-card-wrapper">
  <div class="payment-logo-wrapper">
    <i class="icon-btn" i-bs [name]="isCard ? 'credit-card' : (paymentMethod ? 'wallet2' : 'currency-euro')" width="60" height="60"></i>
  </div>
  <div class="payment-informations-wrapper">
    <h6 class="payment-type-title">{{ isCard ? (paymentMethod?.cardBrand | uppercase) : (paymentMethod ? 'Compte bancaire' : 'Moyen de paiement inconnu') }} <span *ngIf="paymentMethod?.default" class="default-payment-method">Par défaut</span></h6>
    <div class="d-flex w-100 justify-content-between">
      <div class="payment-informations-details-wrapper">
      <span class="payment-description-label">{{
          isCard
            ? 'Carte Bancaire : •••• •••• •••• ' + paymentMethod?.cardLast4Digits + getExpiration()
            : (paymentMethod
                ? 'Code SEPA : •• ••' + (paymentMethod?.sepaBankCode ?? '•••••') + '••• •••• ••••'
                : "Aucun moyen de paiement n'est actuellement défini."
            )
        }}
      </span>
        <span class="payment-name-label">Titulaire : {{ paymentMethod?.owner ?? 'Inconnu' }}</span>
      </div>

      <button *ngIf="withModifyButton && paymentMethod?.default" class="btn btn-primary btn-gradient modify-payment-information-button"
              (click)="modifyPaymentInformation()">
        <ng-container *ngIf="loading; else modifyButtonTemplate">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </ng-container>
        <ng-template #modifyButtonTemplate>
          Modifier
        </ng-template>
      </button>

      <button *ngIf="withModifyButton && !paymentMethod?.default && default" class="btn btn-outline modify-payment-information-button"
              (click)="defaultPaymentInformation()">
        <ng-container *ngIf="loading; else modifyButtonTemplate">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </ng-container>
        <ng-template #modifyButtonTemplate>
          Définir par défaut
        </ng-template>
      </button>
    </div>
  </div>
</div>
